import React from 'react';
import FilteredThread from '../components/FilteredThread';

const Articles = () => {
    return (
        <FilteredThread type="article" />
    );
};

export default Articles;